import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text" width="100%" theme="lightest" alignment="yes" className="py-0 text-align-left div-p-0 left-content accessibility-text-blade text-blade-header heading-accessibility" mdxType="TextBlock" />
    <h2 {...{
      "id": "interested-in-joining-the-beta-program-for-adobe-pdf-electronic-seal-api"
    }}>{`Interested in joining the Beta Program for Adobe PDF Electronic Seal API?`}</h2>
    <p>{`The `}<a href="https://developer.adobe.com/document-services/docs/overview/pdf-electronic-seal-api/">{`PDF Electronic Seal API`}</a>{` allows organizations to apply an electronic seal (e-seal) to a PDF document using a digital certificate, which helps verify the identity and integrity of a document.`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <p>{`Primary capabilities of the API include:`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Works with certificates from various Trust Service Providers (TSPs) or Certificate Authorities (CA), which bolsters document integrity and organizational identity`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Provides timestamp`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Support for batch sealing or high-volume use cases`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`End-to-end cloud-based service`}</p>
      </li>
    </ul>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <p>{`Use this form to have an Adobe representative contact you with more information about the Beta program or to answer other questions you have about the API.`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade accessibility-content link linking" mdxType="TextBlock" />
    <p>{`You can also find more information in the `}<a title="developer documentation" href="https://developer.adobe.com/document-services/docs/overview/pdf-electronic-seal-api/">{`developer documentation.`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      